/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangePassword200Response
 */
export interface ChangePassword200Response {
    /**
     * ステータス
     * @type {number}
     * @memberof ChangePassword200Response
     */
    status: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof ChangePassword200Response
     */
    message: string;
    /**
     * 再発行認証トークン
     * @type {string}
     * @memberof ChangePassword200Response
     */
    adminToken?: string;
}

/**
 * Check if a given object implements the ChangePassword200Response interface.
 */
export function instanceOfChangePassword200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function ChangePassword200ResponseFromJSON(json: any): ChangePassword200Response {
    return ChangePassword200ResponseFromJSONTyped(json, false);
}

export function ChangePassword200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangePassword200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'adminToken': !exists(json, 'admin_token') ? undefined : json['admin_token'],
    };
}

export function ChangePassword200ResponseToJSON(value?: ChangePassword200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'admin_token': value.adminToken,
    };
}

